export const standardizePhoneNumber = (phone: string) => {
    const value = phone;
    let mobile = value;
    if (value.startsWith('+840')) {
        // remove +840 in phone number
        mobile = value.replace('+840', '+84');
    }
    if (value.startsWith('00')) {
        // remove +840 in phone number
        mobile = value.replace('00', '0');
    }
    return mobile;
};

/**
 * Format phone number with spaces for display
 */
export const formatPhoneNumber = (value: string): string => {
    // Using `replace` instead of `replaceAll` because the project TypeScript target/lib
    // does not include ES2021 yet. Updating the lib would impact multiple packages,
    // so we keep `replace` here for compatibility.
    const cleaned = value.replace(/\s+/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
};
